"use client"

import Script from "next/script"

interface GoogleTagManagerProps {
	gtmId: string | null | undefined
}

export function GoogleTagManager({ gtmId }: GoogleTagManagerProps) {
	if (!gtmId) return null

	return (
		<>
			{/* GTM Script - loads in head */}
			<Script
				id="gtm-script"
				strategy="lazyOnload"
				dangerouslySetInnerHTML={{
					__html: `
						(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
						new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
						j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
						'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
						})(window,document,'script','dataLayer','${gtmId}');
					`,
				}}
			/>
			{/* GTM NoScript - for users without JavaScript */}
			<noscript
				dangerouslySetInnerHTML={{
					__html: `
						<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
						height="0" width="0" 
						style="display:none;visibility:hidden"></iframe>
					`,
				}}
			/>
		</>
	)
}
